export const hope_course = [
  {
    title: '',
    value: '',
  },
  {
    title: 'ことば学習コース',
    value: 'ことば学習コース',
  },
  {
    title: '教科学習コース',
    value: '教科学習コース',
  },
  {
    title: 'まだ決めてない',
    value: 'まだ決めてない',
  },
];

export function getPriceByHopeCourse(hope_course: string): number {
  if (hope_course === 'ことば学習コース') {
    return 1800;
  } else if (hope_course === '教科学習コース') {
    return 2500;
  } else {
    return 0;
  }
}
